import Vue from "vue";
import Router from "vue-router";
import routes from './routes.js'
import Auth from '@/auth.js'

Vue.use(Router);

const router = new Router({ routes });

//当从host/#/index 切换到 host/#/book-detail/34的时候，
//在路由的钩子中，以及在钩子函数中调用的函数中，location.href 的值 和 to.fullPath的值是不一致的。
//至少在router.afterEach()当中还是不一致的
//不一致是指： location.href == host/#/index  but   to.fullPath == '/book-detail/34'
//直到路由对应的组件被渲染完成，或者在这之前的某一段短时间内，loactaion.href 和 to.fullPath才会一致。在组件的created,mounted中是一致的。
//一致是指：location.href == host/#/book-detail/34  but   to.fullPath == '/book-detail/34'

//就好像location.href的值的改变有些延迟

//全局前置守卫
router.beforeEach((to, from, next) => {
    // console.log('in beforeEach location.href: ', location.href);
    // console.log('in beforeEach fullPath     : ', to.fullPath);

    // console.log('in beforeEach :', cookie.get('userId'))
     // console.log(to.fullPath,'to.fullPath')
    let  title = to.meta && to.meta.title;
    if (title) {
      document.title = title;
    }

    //微信授权管理
    //Auth(to, from, next);

    if(to.query && to.query['userId'] != undefined){
        // console.log('is going to deUserId: ', )
        //路由模式为哈希模式：
        //只有#后面的内容才会被解析成 route 对象中的属性值 name params query ...
        //如果是 http://hxcs.v5time.net/   进入页面的话
        //name 属性是解析为空的
        let url = JSON.stringify({
            name: to.name || "index",
            params: to.params,
            query:  to.query
        });

        next({
          name: 'deUserId',
          query: {
            directUrl: url
          }
        })
    };
    next();
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export { router };





// WEBPACK FOOTER //
// ./src/router/index.js